import { render, staticRenderFns } from "./UserCampaignTable.vue?vue&type=template&id=707bcc49&"
import script from "./UserCampaignTable.vue?vue&type=script&lang=js&"
export * from "./UserCampaignTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports